import SSSlideDisplayer from './00-slideshare_slide_displayer';

function SSInfographicDisplayer(config){
  if (typeof config === "undefined"){
    return;
  }
  SSSlideDisplayer.call(this, config);
}

SSInfographicDisplayer.prototype = new SSSlideDisplayer();

SSInfographicDisplayer.prototype.start = function(config){
  if (typeof this.slidesContainer === 'undefined'){
    this.slidesContainer = $('.slide_container');
    this.bindEvents();
  }
  if (this.config.playerBgColor){
    this.playerBgColor = this.config.playerBgColor;
  }
  this.slides = config.slides;
  this.slide = this.slides[1];
  this.slideContainer = this.slidesContainer.children(".slide");
  this.slide.setContainer({
    mode : config.mode,
    bgColor : this.playerBgColor,
    container : this.slideContainer
  });
};

SSInfographicDisplayer.prototype.bindEvents = function(){
  if (!this.config.isMobileDevice){
    this.slidesContainer.bind('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      $.slideshareEventManager.trigger('viewfullscreen');
    });
  }
};

SSInfographicDisplayer.prototype.setDimensions = function(dimensions){
  var that = this;
  if (typeof dimensions === 'object'){
    this.config.width = dimensions.width;
    this.config.height = dimensions.height;
  }
};

SSInfographicDisplayer.prototype.emptySlides = function(){};

SSInfographicDisplayer.prototype.setPrerenderedSlides = function(){};

SSInfographicDisplayer.prototype.showInitializer = function(){
  if (!this.config.show_image_player) {
    $('<div/>').addClass('.jsplInitializer').css({
      width : this.container.width() - 10,
      height : this.container.height() - 20
    }).text(slideshare_object.utils.i18n(
        'slideshow.foundation_slideview.loading'
      )
    ).appendTo(this.container);
  }
};

SSInfographicDisplayer.prototype._scrollTo = function(index){
  if(this.config.show_image_player){
    var slides = this.slidesContainer.children();
    slides.removeClass("show");
    slides.eq(index - 1).addClass("show");
    return;
  }
};

export default SSInfographicDisplayer;